import angular from 'angular';

export const ConfiguracaoDocumentosListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider): void {
        $stateProvider
            .state('meurh_config_documentos', {
            url: '/tipos-de-documentos',
            template: require('html-loader!./index/configuracaodocumentos.index.html'),
            controller: 'ConfiguracaoDocumentosIndexController',
            controllerAs: 'cfgdocs_cntrllr',
        });
    }
];
